import React from 'react'
import Moment from "react-moment"
import { Link } from 'react-router-dom'
import Chip from '@material-ui/core/Chip';

const settingsTabs = [
    { label: 'Customers' },
    { label: 'Client Portals'},
    { label: 'Feature Flags' }
]

const clientSettingsTab = [
    { label: 'User' },
    { label: 'Sales Representative' },
    { label: 'Templates' },
    { label: "Billing" },
    { label: 'Client Information' }
]

const cardMapping = [
    {
        url: '/settings/platform-partners',
        icon: 'handShake.svg',
        heading: 'Platform Partners',
        bodyText: 'Add, update, and delete partners',
        buttonText: 'Manage Partners',
    },
    {
        url: '/settings/clients',
        icon: 'users.svg',
        heading: 'Customer',
        bodyText: 'Add, update, and delete customers',
        buttonText: 'Manage Customers',
    },
    {
        url: '/settings/data-sources',
        icon: 'handShake.svg',
        heading: 'Data Sources',
        bodyText: 'Federal registries & exclusion lists — mirror status and ingest controls',
        buttonText: 'Open',
    },
    {
        url: '/settings/interaction-responses',
        icon: 'handShake.svg',
        heading: 'Interaction Responses',
        bodyText: 'Search raw interaction logs by type, name, client',
        buttonText: 'Open Search',
    },
    {
        url: '/settings/received-hooks',
        icon: 'handShake.svg',
        heading: 'Received Webhooks',
        bodyText: 'Inbound webhooks from Plaid, Cobalt, DocuSign, Stripe, FCS',
        buttonText: 'Open Search',
    },
    {
        url: '/settings/notification-emails',
        icon: 'handShake.svg',
        heading: 'Notification Emails',
        bodyText: 'Manage who gets sign-up, plan-change, and state-Medicaid digest emails',
        buttonText: 'Manage Recipients',
    },
    {
        url: '/settings/email-templates',
        icon: 'handShake.svg',
        heading: 'Email Templates',
        bodyText: 'Every email the platform sends, previewed with sample data',
        buttonText: 'View Templates',
    },
]

const clientPortalsColumns = [
    {
        dataField: 'clientName',
        text: 'Client Name',
        headerStyle: {
            width: '16rem'
        },
        formatter: (cell, row) => {
            return (
                <Link className={'id-hyper-link'}
                      to={`/settings/client/${row.clientUuid}`}
                >
                    {cell}
                </Link>
            )
        }
    },
    {
        dataField: 'pageName',
        text: 'Page Name'
    },
    {
        dataField: 'url',
        text: 'URL',
        formatter: (cell) => (
            <a href={cell} target="_blank" rel="noopener noreferrer" className="id-hyper-link">
                {cell}
            </a>
        )
    },
    {
        dataField: 'createdAt',
        text: 'Created At',
        formatter: (cell) => {
            return <Moment format="MM/DD/YYYY">{cell}</Moment>
        }
    }
]

const customerColumns = (plaformPartner) => [
    {
        dataField: 'name',
        text: 'Name',
        headerStyle: {
            width: plaformPartner ? 'auto' : '16rem'
        },
        formatter: (cell, row) => {
            return (
                <Link className={'id-hyper-link'}
                    to={`/settings/client/${row.uuid}`}
                >
                    {cell}
                </Link>
            )
        }
    },
    {
        dataField: 'status',
        text: 'Status',
        formatter : (cell) => (
            <div><div className={`table-label ${cell?.toLowerCase()}`}>{cell}</div></div>
        ),
    },
    {
        dataField: 'businessType',
        text: 'Business Type'
    },
    {
        dataField: 'selfRegistered',
        text: 'Self Registered',
        formatter: (cell, row) => (
            <div>{cell ? 'Yes' : row?.registrationSource === 'EMAIL_CAMPAIGN' ? 'Email campaign' : 'No'}</div>
        )
    },
    {
        dataField: 'usesCredits',
        text: 'Uses Credits',
        sort: false,
        formatter: (cell) => (<div>{cell ? 'Yes' : 'No'}</div>)
    },
    {
        dataField: 'createdBy.name',
        text: 'Created By'
    },
    {
        dataField: 'updatedBy.name',
        text: 'Updated By'
    },
    {
        dataField: 'createdAt',
        text: 'Created At',
        formatter: (cell) => {
            return <Moment format="MM/DD/YYYY">{cell}</Moment>
        }
    },
    {
        dataField: 'updatedAt',
        text: 'Updated At',
        formatter: (cell) => {
            return <Moment format="MM/DD/YYYY">{cell}</Moment>
        },
        headerStyle: {
            width: '9rem'
        },
    },
    {
        dataField: 'action',
        headerStyle: {
            width: '70px',
            cursor: 'pointer'
        },
        sort: false,
        hideColumn: true
    }
]

const customerList = [
    {
        uuid: '4eaaldjf223l324l2342342',
        name: 'Alladin',
        email: 'alladin@gmail.com',
        domain: 'Carrier',
        createdAt: new Date()
    },
    {
        uuid: '4eaaldjf223l324l2342342',
        name: 'Shiva',
        email: 'shiva@gmail.com',
        domain: 'Transport',
        createdAt: new Date()
    },
    {
        uuid: '4eaaldjf223l324l2342342',
        name: 'James',
        email: 'james@gmail.com',
        domain: 'Carrier',
        createdAt: new Date()
    },
]

const customerFilters = [
    {
        id: 'clientName',
        type: 'text',
        label: 'Customer Name',
        defaultValue: ''
    },
]

const billingColumns = [
    {
        dataField: 'applicationName',
        text: 'Application Name'
    },
    {
        dataField: 'reportName',
        text: 'Report Name'
    },
    {
        dataField: 'requestedBy',
        text: 'Requested By'
    },
    {
        dataField: 'date',
        text: 'Date',
        formatter: (cell) => cell ? <Moment format="MM/DD/YYYY">{cell}</Moment> : ''
    },
    {
        dataField: 'creditCost',
        text: 'Credit Cost'
    },
{
    dataField: 'status',
    text: 'Status',
    headerStyle: {
        textAlign: 'center',
        width: '11rem'
    },
    formatter: (cell) => (
        <Chip
            label={cell === 'successfull' ? 'Successful' : 'Error'}
            style={{
                backgroundColor: cell === 'successfull' ? 'var(--status-approved)' : 'var(--status-declined)',
                color: '#fff'
            }}
            size="small"
        />
    )
}
]

// Account types the backend never asks for a second factor, regardless of the client
// configuration: machine accounts have no mailbox and the client portal has its own auth.
const EXEMPT_BY_ACCOUNT_TYPE = [
    'SERVICE_ACCOUNT',
    'ADMIN_ACCOUNT',
    'SYSTEM_ACCOUNT',
    'GMAIL_INTEGRATION_ACCOUNT',
    'CLIENT_PORTAL_USER'
]

const userColumns = [
    {
        dataField: 'username',
        text: 'User Name',
        headerStyle: {
            width: '16rem'
        },
        formatter: (cell, row) => {
            return <div>{`${row.firstName} ${row.lastName}`}</div>
        }
    },
    {
        dataField: 'email',
        text: 'Email'
    },
    {
        dataField: 'phone',
        text: 'Phone'
    },
    {
        dataField: 'roles',
        text: 'Role',
        formatter: (cell) => {
            return cell?.map(role => role.name).join(', ')
        }
    },
    {
        dataField: 'status',
        text: 'Status',
        headerStyle: {
            textAlign: 'center',
            width: '11rem'
        },
        checkboxDisable: true,
        formatter: (cell) => (
            <div><div className={`table-label ${cell?.toLowerCase()}`}>{cell}</div></div>
        )
    },
    {
        dataField: 'twoFactorExempt',
        text: '2FA exemption',
        headerStyle: {
            textAlign: 'center',
            width: '9rem'
        },
        sort: false,
        checkboxDisable: true,
        // States the exemption, not the requirement, so it reads correctly whether or not the
        // client has two-factor turned on. Machine accounts and portal users are exempt by
        // account type, which is not configurable, so they read as such.
        formatter: (cell, row) => {
            if (EXEMPT_BY_ACCOUNT_TYPE.includes(row.type)) {
                return <div className='blueLabel'>By account type</div>
            }
            return (
                <div className={cell ? 'yellowLabel' : 'greenLabel'}>
                    {cell ? 'Exempt' : 'None'}
                </div>
            )
        }
    },
    {
        dataField: 'action',
        headerStyle: {
            width: '10rem',
            cursor: 'pointer'
        },
        // Up to three icon buttons (enable/disable, 2FA exemption, edit): never clip them with an ellipsis.
        style: {
            overflow: 'visible',
            textOverflow: 'clip',
            whiteSpace: 'nowrap'
        },
        sort: false,
        show: false,
        hideColumn: true,
        text: ''
    }
]

const templateColumns = [
    {
        dataField: 'description',
        text: 'Name',
        style: {
            whiteSpace: 'initial'
        }
    },
    {
        dataField: 'createdBy',
        text: 'Created By',
        formatter: (cell) => (
            <div>{cell.firstName} {cell.lastName}</div>
        ),
    },
    {
        dataField: 'templateText',
        text: 'Description',
        style: {
            display: '-webkit-box',
            overflow: 'hidden',
            height: '52px',
            whiteSpace: 'initial',
            WebkitLineClamp: '2',
            WebkitBoxOrient: 'vertical',
            textOverflow: 'ellipsis',
        }
    },
]

const salesRepresentativeColumns = [
    {
        dataField: 'name',
        text: 'Name',
        headerStyle: {
            width: '16rem'
        },
        formatter: (cell, row) => {
            return <div>{`${row.firstName} ${row.lastName}`}</div>
        }
    },
    {
        dataField: 'email',
        text: 'Email'
    },
    {
        dataField: 'phoneNumber',
        text: 'Phone'
    },
    {
        // Only for clients with sales rep users
        dataField: 'sharedApplications',
        text: 'Shared applications'
    },
    {
        dataField: 'createdBy.name',
        text: 'Created By',
    },
    {
        dataField: 'action',
        text: 'Actions',
        // Room for the create-login action next to edit and delete
        headerStyle: {
            width: '9.5rem',
        },
    }
]

const platformPartnersColumns = [
    {
        dataField: 'name',
        text: 'Name',
    },
    {
        dataField: 'username',
        text: 'Username'
    },
    {
        dataField: 'active',
        text: 'Status',
        formatter: (cell) => (<div>{cell ? 'Enabled' : 'Disabled'}</div>)
    },
    {
        dataField: 'action',
        text: 'Actions',
        headerStyle: { width: '9rem' }
    }
]

const CsvColumns = [
    {
        dataField: 'uuid',
        text: 'Ingestion Id',
        headerStyle: { width: '25rem' }
    },
    {
        dataField: 'numberOfRows',
        text: 'Number of Record'
    },
    {
        dataField: 'status',
        text: 'Status',
    },
    {
        dataField: 'importDate',
        text: 'Created At',
        formatter: cell => <Moment format="Do MMM YY">{cell}</Moment>
    }
]

const authorizationColumns = [
    {
        dataField: 'client.name',
        text: 'Client Name',
    },
    {
        dataField: 'serviceAccount.username',
        text: 'Service Account Name',
        style: { whiteSpace: 'initial', wordBreak: 'break-all' }
    },
    {
        dataField: 'serviceAccount.roles',
        text: 'Role',
        formatter: (cell, row) => {
            if (cell?.length)
                return cell.map((role, i) => <div key={i}>{role}</div>)
        }
    },
    {
        dataField: 'active',
        text: 'Status',
        formatter: (cell) => (<div>{cell ? 'Enabled' : 'Disabled'}</div>)
    },
    {
        dataField: 'action',
        text: 'Action',
        headerStyle: { width: '7rem' }
    }
]

const userList = [
    {
        uuid: '4eaaldjf223l324l2342342',
        name: 'Alladin',
        email: 'alladin@gmail.com',
        role: 'Admin',
        createdAt: new Date(),
        status: 'Active'
    },
    {
        uuid: '4eaaldjf223l324l2342342',
        name: 'Shiva',
        email: 'shiva@gmail.com',
        role: 'Admin',
        createdAt: new Date(),
        status: 'Active'
    },
    {
        uuid: '4eaaldjf223l324l2342342',
        name: 'James',
        email: 'james@gmail.com',
        role: 'Admin',
        createdAt: new Date(),
        status: 'Active'
    },
]
const userFilter = [
    {
        id: 'name',
        type: 'text',
        label: 'User Name',
        defaultValue: ''
    },
]

// Only offered when the client has credit memo approval turned on.
const creditMemoApproverFilter = {
    id: 'creditMemoApprover',
    type: 'dropdown',
    label: 'Credit memo approver',
    options: [
        { value: 'true', label: 'Approvers' },
        { value: 'false', label: 'Not approvers' },
    ],
}

const templateFilter = [
    {
        id: 'name',
        type: 'text',
        label: 'Name',
        defaultValue: ''
    },
    {
        id: 'createdBy',
        type: 'dropdown',
        label: 'Created By',
        options: []
    },
]

export {
    settingsTabs,
    clientSettingsTab,
    customerColumns,
    customerList,
    customerFilters,
    userColumns,
    EXEMPT_BY_ACCOUNT_TYPE,
    userList,
    userFilter,
    creditMemoApproverFilter,
    templateFilter,
    templateColumns,
    salesRepresentativeColumns,
    cardMapping,
    platformPartnersColumns,
    CsvColumns,
    authorizationColumns,
    billingColumns,
    clientPortalsColumns
}